import React, {Component} from "react"
import {connect} from "react-redux";
import withStyles from "@mui/styles/withStyles";
import {withRouter} from "react-router-dom";
import LinearProgress from "@mui/material/LinearProgress";
import {Box, Button, Paper, Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import Typography from "@mui/material/Typography";
import {get_orders} from "../actions/orders";
import {formatDateTime} from "../utilities/date";
import GetAppIcon from '@mui/icons-material/GetApp';
import VisibilityIcon from '@mui/icons-material/Visibility';

const styles = {
    paper: {
        margin: 15
    },
    fab: {
        position: 'absolute',
        bottom: "40px",
        right: "20px",
    },
};


class Orders extends Component {

    constructor(props) {
        super(props);
        this.state = {
            orders: null
        }
    }

    componentDidMount() {
        this.refreshCoupons();
    }

    refreshCoupons() {
        get_orders().then(r => {
            this.setState({
                ...this.state,
                orders: r.data
            });
        });
    }

    render() {
        if (this.state.orders === null) {
            return <LinearProgress/>
        }
        const {classes} = this.props;
        return (<Box className={classes.paper}>
            <Typography variant={"h5"} gutterBottom={true}>Orders</Typography>
            <Paper>
                <Table>
                    <TableHead>
                        <TableRow>
                            {<TableCell align="center">#</TableCell>}
                            <TableCell align="center">Customer</TableCell>
                            <TableCell align="center">Order status</TableCell>
                            <TableCell align="center">Coupon</TableCell>
                            <TableCell align="center">Created at</TableCell>
                            <TableCell align="center">Price</TableCell>
                            <TableCell align="center">Variant</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.state.orders.map((order) =>
                            <TableRow key={order.id}>
                                {<TableCell align="center">{order.id}</TableCell>}
                                <TableCell
                                    align="center">{[order.first_name, order.last_name].join(" ")}</TableCell>
                                <TableCell align="center">{order.order_status}</TableCell>
                                <TableCell align="center">{order.coupon ? "YES" : "NO"}</TableCell>
                                <TableCell align="center">{formatDateTime(new Date(order.created_at))}</TableCell>
                                <TableCell align="center">{order.price} EUR</TableCell>
                                <TableCell align="center">{order.days === 365 ? "Year" : "Month"}</TableCell>
                                <TableCell>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        className={classes.button}
                                        startIcon={<VisibilityIcon/>}
                                        onClick={() => {
                                            this.props.history.push("/orders/" + order.id);
                                        }}
                                        style={{marginRight: 10}}
                                    >
                                        View
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        className={classes.button}
                                        startIcon={<GetAppIcon/>}
                                        href={order.download}
                                        disabled={order.download === null}
                                        target={"_blank"}
                                        style={{marginRight: 10}}
                                    >
                                        PDF
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        className={classes.button}
                                        startIcon={<GetAppIcon/>}
                                        disabled={order.download === null}
                                        href={order.download + "&type=xml"}
                                        target={"_blank"}
                                    >
                                        XML
                                    </Button>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </Paper>
        </Box>)
    }
}

const mapStateToProps = state => ({});

export default withRouter(withStyles(styles)(connect(
    mapStateToProps,
    {}
)(Orders)));
